<!-- 用户微盟或者其他第三方页面跳转至app内或者其他页面-->
<template>
  <div class=""></div>
</template>
<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {
    let route = this.$route.query?.route || ''
    console.log('路由是', route)
    this.$http.appBack()
    if (route) {
      this.$betterwe.jumpRoute(route)
    }
    
  },
  methods: {}
}
</script>
<style lang="scss" scoped></style>
